// extracted by mini-css-extract-plugin
module.exports = {"root":"textStory_root__1IQYo","text":"textStory_text__10o0Y"};